import axios from "../axios-defaults";

const updateSettings = (role, data, id) => {
  return axios.post(`v1/account`, data);
};

export { updateSettings };
